module.exports = __webpack_public_path__ + "img/17_49.b13795eb.png";